import "quasar/dist/quasar.css";
import lang from "quasar/lang/pt-BR.js";
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/material-icons/material-icons.css";
import Notify from 'quasar/src/plugins/notify/Notify.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';import Loading from 'quasar/src/plugins/loading/Loading.js';;
import "@quasar/extras/mdi-v6/mdi-v6.css";

// To be used on app.use(Quasar, { ... })
export default {
  config: {
    brand: {
      primary: "#111E4B",
    },
  },
  plugins: {
    Notify,
    Dialog,
    Loading,
  },
  lang: lang,
};
